export const experienceData = [
  {
    id: "capgemini-fulltime",
    role: "Cloud & DevOps Engineer",
    company: "Capgemini",
    type: "Full-Time",
    location: "India",
    duration: "Aug. 2026 – Present",
    current: true,
    logo: "/images/capgemini.svg",
    description: "Working as a full-time engineer at Capgemini, engineering scalable cloud infrastructure on AWS & Azure, automating enterprise CI/CD deployment pipelines, containerizing services with Docker & Kubernetes, and driving SRE observability.",
    skills: ["AWS", "Azure", "Docker", "Kubernetes", "CI/CD Automation", "Terraform", "SRE & Observability", "Linux"],
    certificateLink: null
  },
  {
    id: "capgemini-exceller-fellowship",
    role: "Exceller Edge Fellowship — Cloud & DevOps",
    company: "Capgemini",
    type: "Professional Training & Fellowship",
    location: "Haldia Institute of Technology & Capgemini",
    duration: "Jan. 2026 – May 2026",
    current: false,
    logo: "/images/capgemini.svg",
    description: "Completed intensive, hands-on Cloud & DevOps training covering AWS, Azure, Docker, Kubernetes, Jenkins, Terraform, Ansible, GitOps, Prometheus, Grafana, Maven, and Linux. Developed practical expertise in cloud infrastructure, CI/CD automation, container orchestration, Infrastructure as Code (IaC), and monitoring.",
    skills: ["AWS", "Azure", "Docker", "Kubernetes", "Jenkins", "Terraform", "Ansible", "GitOps", "Prometheus", "Grafana", "Linux"],
    certificateLink: "https://drive.google.com/file/d/1XM06y-NZtoVujy1aFMED_0o6rcXStOKA/view",
    certificateId: "CEEFP2026-7060737"
  }
];
